import React, { useEffect, useState } from 'react'
import ImageWithBasePath from '../imageWithBasePath'
import { logo, logoColor } from '../data/json/header'
import { Link, useLocation } from 'react-router-dom'
import { all_routes } from '../../../feature-module/router/all_routes'
import { useSelector } from 'react-redux'
import { useAuth } from '../../../provider/AuthProvider'
import ProfileDropdown from './profile'
import { ApiMenu, getHeaderMenus } from '../../../api/setting'

export interface HeaderMenu {
  tittle: string;
  base: string;
  type: string;
  showAsTab: boolean;
  separateRoute: boolean;
  route: string;
  menu: {
    menuValue: string;
    hasSubRoute: boolean;
    route: string;
  }[];
}

const Header = () => {
  const { isAuthenticated } = useAuth()

  const [scrolled, setScrolled] = useState(false)
  const [isMegaMenu, setIsMegaMenu] = useState(false)
  const [subOpen, setSubopen] = useState<any>('')
  const [subsidebar, setSubsidebar] = useState('')
  const [subsidebar2, setSubsidebar2] = useState('')
  const [basePath, setBasePath] = useState('')
  const [showButtonSidebar, setShowButtonSidebar] = useState(false)
  const location = useLocation()
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme)

  const [header, setHeader] = useState<HeaderMenu[]>([]);

  const formatHeader = (menus: ApiMenu[]): HeaderMenu[] => {
    return menus.map(menu => ({
      tittle: menu.name,
      base: menu.link || "",
      type: menu.type,
      showAsTab: false,
      separateRoute: false,
      route: menu.link || "#",
      menu: menu.items.map(item => ({
        menuValue: item.name,
        hasSubRoute: false,
        route: item.link,
      })),
    }));
  };

  useEffect(() => {
    const fetchHeader = async () => {
      try {
        const apiData = await getHeaderMenus()
        setHeader(formatHeader(apiData));
      } catch (err) {
        console.error("Failed to fetch header menus", err)
      }
    }

    fetchHeader()
  }, [])

  const onHandleMobileMenu = () => {
    setShowButtonSidebar(true)
    const root = document.getElementsByTagName('html')[0]
    root.classList.add('menu-opened')
  }
  const onhandleCloseMenu = () => {
    setShowButtonSidebar(false)
    const root = document.getElementsByTagName('html')[0]
    root.classList.remove('menu-opened')
  }

  const toggleSidebar = (title: any) => {
    localStorage.setItem('menuOpened', title)
    if (title === subOpen) {
      setSubopen('')
    } else {
      setSubopen(title)
    }
  }
  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar('')
    } else {
      setSubsidebar(subitem)
    }
  }
  const toggleSubsidebar2 = (subitem: any) => {
    if (subitem === subsidebar2) {
      setSubsidebar2('')
    } else {
      setSubsidebar2(subitem)
    }
  }
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    // Add event listener
    window.addEventListener('scroll', handleScroll)

    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    document.documentElement.setAttribute('class', dataTheme)
  }, [dataTheme])

  useEffect(() => {
    const path = location.pathname
    const pathArray = path.split('/').filter(Boolean) // Removes empty strings from the split result

    setBasePath(pathArray[0])
  }, [location.pathname])

  const AuthButton = () => {
    const handleClick = () => {
      const root = document.getElementsByTagName('html')[0]
      root.classList.remove('menu-opened')
    }

    return (
      <>
        <Link
          to={all_routes.login}
          className="btn btn-white d-inline-flex align-items-center me-2"
          onClick={handleClick}
        >
          Masuk
        </Link>
        <Link
          to={all_routes.register}
          className="btn btn-yellow me-0"
          onClick={handleClick}
        >
          Daftar Gratis
        </Link>
      </>
    )
  }

  return (
    <>
      <header
        className={`header-one ${location.pathname === '/'
          ? 'position-fixed'
          : 'position-relative'
          } ${scrolled ? 'fixed' : ''}`}
      >
        <div className="container">
          <div className="header-nav">
            <div className="navbar-header">
              <Link id="mobile_btn" to="#" onClick={() => onHandleMobileMenu()}>
                <span className="bar-icon">
                  <i className="isax isax-menu"></i>
                </span>
              </Link>
              <div className="navbar-logo">
                <Link
                  className="logo-white header-logo"
                  to={all_routes.homeone}
                >
                  <ImageWithBasePath
                    src={logo}
                    width={110}
                    className="logo"
                    alt="Logo"
                  />
                </Link>
                <Link className="logo-dark header-logo" to={all_routes.homeone}>
                  <ImageWithBasePath
                    src={logo}
                    width={110}
                    className="logo"
                    alt="Logo"
                  />
                </Link>
              </div>
            </div>
            <div className={`main-menu-wrapper ${isMegaMenu ? 'active' : ''}`}>
              <div className="menu-header">
                <Link to={all_routes.homeone} className="menu-logo">
                  <ImageWithBasePath
                    src={logo}
                    width={110}
                    className="img-fluid"
                    alt="Logo"
                  />
                </Link>
                <Link
                  id="menu_close"
                  className="menu-close"
                  to="#"
                  onClick={() => onhandleCloseMenu()}
                >
                  <i className="fas fa-times" />
                </Link>
              </div>
              <ul className={`main-nav ${isMegaMenu ? 'active' : ''}`}>
                {header.map((mainMenus: any, mainIndex) => (
                  <React.Fragment key={mainIndex}>
                    {mainMenus.separateRoute ? (
                      <li
                        key={mainIndex}
                        className={`has-submenu megamenu ${mainMenus.route === location.pathname ? 'active' : ''
                          }`}
                        onClick={() => toggleSidebar(mainMenus.tittle)}
                        onMouseOver={() => setIsMegaMenu(true)}
                        onMouseLeave={() => setIsMegaMenu(false)}
                      >
                        <Link to="#">
                          {mainMenus.tittle}
                          <i
                            className={` ${basePath === 'instructor' ||
                              basePath === 'student'
                              ? 'isax isax-add'
                              : 'fas fa-chevron-down'
                              }`}
                          />
                        </Link>
                        <ul
                          className={`submenu mega-submenu ${subOpen === mainMenus.tittle ? 'd-block' : ''
                            }`}
                          onMouseOver={() => setIsMegaMenu(true)}
                          onMouseLeave={() => setIsMegaMenu(false)}
                        >
                          <li>
                            <div className="megamenu-wrapper">
                              <div className="row">
                                {mainMenus.menu.map((menu: any, idx: any) => (
                                  <div className="col-lg-2" key={idx}>
                                    <div
                                      className={`single-demo ${location.pathname === menu.route
                                        ? 'active'
                                        : ''
                                        }`}
                                    >
                                      <div className="demo-img">
                                        <Link
                                          to={menu.route}
                                          className="inner-demo-img"
                                        >
                                          <ImageWithBasePath
                                            src={menu.img}
                                            className="img-fluid "
                                            alt="img"
                                          />
                                        </Link>
                                      </div>
                                      <div className="demo-info">
                                        <Link
                                          to={menu.route}
                                          className="inner-demo-img"
                                        >
                                          {menu.menuValue}
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                    ) : (
                      <li
                        className={`has-submenu ${mainMenus.route === location.pathname ? 'active' : ''
                          }`}
                      >
                        <Link
                          to={
                            mainMenus?.menu?.length > 0 && mainMenus?.type === 'dropdown' ? '#' : mainMenus?.route
                          }
                          onClick={() => toggleSidebar(mainMenus.tittle)}
                        >
                          {mainMenus.tittle}{' '}
                          {mainMenus?.menu?.length > 0 && mainMenus?.type === 'dropdown' ? (
                            <i
                              className={`${basePath === 'instructor' ||
                                basePath === 'student'
                                ? 'isax isax-add'
                                : 'fas fa-chevron-down'
                                }`}
                            ></i>
                          ) : null}
                        </Link>
                        {mainMenus?.menu?.length > 0 && mainMenus?.type === 'dropdown' ? (
                          <ul
                            className={`submenu ${subOpen === mainMenus.tittle ? 'd-block' : ''
                              }`}
                          >
                            {mainMenus.menu?.map(
                              (menu: any, menuIndex: any) => (
                                <React.Fragment
                                  key={`${mainIndex}-${menuIndex}`}
                                >
                                  {menu.hasSubRoute ? (
                                    <li
                                      key={`${mainIndex}-${menuIndex}`}
                                      className={`${menu.hasSubRoute ? 'has-submenu' : ''
                                        } ${menu?.subMenus?.some((item: any) =>
                                          item?.route?.includes(
                                            location.pathname,
                                          ),
                                        ) || basePath === menu.base
                                          ? 'active'
                                          : ''
                                        }`}
                                    >
                                      <Link
                                        to="#"
                                        className={`hideonmob`}
                                        onClick={() => {
                                          toggleSubsidebar(menu.menuValue)
                                        }}
                                      >
                                        {menu.menuValue}
                                      </Link>
                                      <ul
                                        className={`submenu showonmob ${subsidebar === menu.menuValue
                                          ? 'd-block'
                                          : ''
                                          }`}
                                      >
                                        {menu.subMenus?.map(
                                          (subMenu: any, subMenuIndex: any) => (
                                            <React.Fragment
                                              key={`${mainIndex}-${menuIndex}-${subMenuIndex}`}
                                            >
                                              {subMenu.hasSubRoute ? (
                                                <li
                                                  className={`${menu.hasSubRoute
                                                    ? 'has-submenu'
                                                    : ''
                                                    } ${subMenu?.subMenus?.some(
                                                      (item: any) =>
                                                        item?.route?.includes(
                                                          location.pathname,
                                                        ),
                                                    )
                                                      ? 'active'
                                                      : ''
                                                    }`}
                                                >
                                                  <Link
                                                    to="#"
                                                    onClick={() => {
                                                      toggleSubsidebar2(
                                                        subMenu.menuValue,
                                                      )
                                                    }}
                                                  >
                                                    {subMenu.menuValue}
                                                  </Link>
                                                  <ul
                                                    className={`submenu ${subsidebar2 ===
                                                      subMenu.menuValue
                                                      ? 'd-block'
                                                      : ''
                                                      }`}
                                                  >
                                                    {subMenu.subMenus?.map(
                                                      (
                                                        menu: any,
                                                        menuIndex2: any,
                                                      ) => (
                                                        <li
                                                          key={menuIndex2}
                                                          className={
                                                            location.pathname ===
                                                              menu.route
                                                              ? 'active'
                                                              : ''
                                                          }
                                                        >
                                                          <Link to={menu.route}>
                                                            {menu.menuValue}
                                                          </Link>
                                                        </li>
                                                      ),
                                                    )}
                                                  </ul>
                                                </li>
                                              ) : (
                                                <li
                                                  className={
                                                    location.pathname ===
                                                      subMenu.route
                                                      ? 'active'
                                                      : ''
                                                  }
                                                  key={`${mainIndex}-${menuIndex}-${subMenuIndex}`}
                                                >
                                                  <Link to={subMenu.route}>
                                                    {subMenu.menuValue}
                                                  </Link>
                                                </li>
                                              )}
                                            </React.Fragment>
                                          ),
                                        )}
                                      </ul>
                                    </li>
                                  ) : (
                                    <li
                                      key={`${mainIndex}-${menuIndex}`}
                                      className={
                                        location.pathname.includes(
                                          menu.route || '',
                                        )
                                          ? 'active'
                                          : ''
                                      }
                                    >
                                      <Link to={menu.route}>
                                        {menu.menuValue}
                                      </Link>
                                    </li>
                                  )}
                                </React.Fragment>
                              ),
                            )}
                          </ul>
                        ) : null}
                      </li>
                    )}
                  </React.Fragment>
                ))}
              </ul>
              {showButtonSidebar ? (
                <div className="text-center mt-4">
                  {isAuthenticated ? (
                    <div style={{ paddingLeft: '20px' }}>
                      <ProfileDropdown />
                    </div>
                  ) : (
                    <AuthButton />
                  )}
                </div>
              ) : null}
            </div>

            <div className="header-btn d-flex align-items-center">
              {/* <DarkButton /> */}
              {isAuthenticated ? <ProfileDropdown /> : <AuthButton />}
            </div>
          </div>
        </div>
      </header>
      {/* /Header */}
    </>
  )
}

export default Header
